import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Your trusted partner for personal and professional growth" 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">My Pro Wingman</p>
        <h1>Your Journey to Success Starts Here.</h1>
        <p className="lede">
          At My Pro Wingman, we provide expert guidance and mentorship tailored to help you achieve your personal and professional goals. Discover the support you need to thrive.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Personalized Mentorship</h2>
          <p>
            Work one-on-one with experienced mentors who understand your unique challenges and aspirations.
          </p>
        </article>
        <article>
          <h2>Workshops & Resources</h2>
          <p>
            Access a variety of workshops and resources designed to equip you with the skills needed for success.
          </p>
        </article>
        <article>
          <h2>Community Support</h2>
          <p>
            Join a vibrant community of like-minded individuals who are on the same journey as you, sharing insights and encouragement.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;